import { render, staticRenderFns } from "./PluginInstallParamsBuilder.vue?vue&type=template&id=1afc370c&scoped=true&"
import script from "./PluginInstallParamsBuilder.vue?vue&type=script&lang=js&"
export * from "./PluginInstallParamsBuilder.vue?vue&type=script&lang=js&"
import style0 from "./PluginInstallParamsBuilder.vue?vue&type=style&index=0&id=1afc370c&prod&scoped=true&lang=scss&"
import style1 from "./PluginInstallParamsBuilder.vue?vue&type=style&index=1&id=1afc370c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afc370c",
  null
  
)

export default component.exports